import { ACTION_TYPE } from '../actions/actionTypes';

const goalSummaryRdesults = (state = [], action) => {
  switch (action.type) {
    case ACTION_TYPE.GET_GOAL_SUMMARY_INVESTMENT_GOAL:
      return {
        ...state,
        currency: action.payload.currency,
        highInvestmentValue: action.payload.highInvestmentValue,
        lowInvestmentValue: action.payload.lowInvestmentValue,
        messageResultCode: action.payload.messageResultCode,
        messageResultTextArabic: action.payload.messageResultTextArabic,
        messageResultTextEn: action.payload.messageResultTextEn,
        period: action.payload.period,
        pastPerformanceList: action.payload.pastPerformanceList,
      };
    default:
      return state;
  }
};

export default goalSummaryRdesults;
